import { ClientAuthPayload, ClientForms } from "../types/client";
import { ProviderList } from "../types/provider";
import moment from "moment";

//comapare dates
export const formattedDate = (item: any): string => {
  let FullDate = item.split("-");
  let Year = parseInt(FullDate[0]);
  let Month = parseInt(FullDate[1]);
  let Date = parseInt(FullDate[2]);

  return ` ${Year}${"/"}${Month}${"/"}${Date}`;
};

// CTO Review: need to test this below!!
// export const formattedDate = (dateStr: string): string => {
//   if (!dateStr) return '';
  
//   const parsed = moment(dateStr, 'YYYY-MM-DD', true);
//   if (!parsed.isValid()) {
//     console.warn('Invalid date format:', dateStr);
//     return '';
//   }
  
//   return parsed.format('YYYY/MM/DD');
// };

//handle provider name
export const getProvidersName = (
  id: string,
  providerform: ProviderList[]
): string => {
  let firstname: {
    firstName: string;
  }[] = [];

  providerform.forEach((unit) => {
    if (unit.id === id) {
      firstname.push(unit);
    }
  });
  return firstname[0]?.firstName;
};

//handle provider name
export const getClientsName = (id: string, data: ClientForms[]) => {
  let firstname: any[] = [];

  data.forEach((unit) => {
    if (unit.clientBasicDetails.id === id) {
      firstname.push(unit.clientBasicDetails);
    }
  });
  return firstname[0]?.childFirstName;
};
export const getBussinessName = (id: string, businessUnits: any[]): string => {
  let initArr: { businessUnitName: any }[] = [];
  businessUnits.forEach((unit) => {
    if (unit.id === id) {
      initArr.push(unit);
    }
  });
  return initArr[0]?.businessUnitName;
};

// Define a function to shorten the file name
export const shortenFileName = (fileName: string, maxLength: number) => {
  if (fileName.length <= maxLength) {
    return fileName;
  }

  const truncatedName = fileName.substring(0, maxLength - 3) + "...";
  return truncatedName;
};

export const returnAuthorizationValue = (item: ClientAuthPayload): string => {
  if (item.insuranceId) {
    if (item.authPeriod) {
      return `${item.insurance.insuranceProviderName} Auth ${
        moment(item.authPeriod.startDate).month() + 1
      }.${moment(item.authPeriod.startDate).date()}.${moment(
        item.authPeriod.endDate
      ).year()} - ${moment(item.authPeriod.endDate).month() + 1}.${moment(
        item.authPeriod.endDate
      ).date()}.${moment(item.authPeriod.endDate).year()}`;
    } else {
      return `${item.insurance.insuranceProviderName} Auth (no date)`; //no date
    }
  }
  return "<bad auth code>";
};

// used for mails
export const getInitials = (name: string) => {
  const [firstName, lastName] = name.trim().split(" ");

  if (!firstName) return ""; // Handle empty string case
  if (!lastName) return firstName.charAt(0).toUpperCase(); // Only first name exists

  return `${firstName.charAt(0).toUpperCase()}${lastName
    .charAt(0)
    .toUpperCase()}`;
};

export const formatTimeStampDate = (
  timestamp: number,
  type: string
): string => {
  const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
  const now = new Date();

  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  const isSameYear = date.getFullYear() === now.getFullYear();

  const formatTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  if (isToday) {
    return type === "Preview" ? `${formatTime}` : `Today, ${formatTime}`;
  } else if (isSameYear) {
    return type === "Preview"
      ? `${date.getDate()} ${date
          .toLocaleString("en-US", {
            month: "short",
          })
          .toUpperCase()}`
      : `${date.getDate()} ${date
          .toLocaleString("en-US", {
            month: "short",
          })
          .toUpperCase()}, ${formatTime}`;
  } else {
    return type === "Preview"
      ? `${date.getMonth() + 1}/${date.getDate()}/${date
          .getFullYear()
          .toString()
          .slice(-2)}`
      : `${date.getMonth() + 1}/${date.getDate()}/${date
          .getFullYear()
          .toString()
          .slice(-2)}, ${formatTime}`;
  }
};
